import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EditorInstance, EditorOption } from 'angular-markdown-editor';
import { MarkdownService } from 'ngx-markdown';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { User } from '../../../store/authentication/model/user.model';
import { UserManagementFacadeService } from '../../../services/management/user-management-facade.service';
import { TableResponse } from '../../../models/table/table-response.model';

@Component({
    selector: 'app-message-to-user-modal',
    templateUrl: './message-to-user-modal.component.html',
    styleUrl: './message-to-user-modal.component.scss'
})
export class MessageToUserModalComponent implements OnInit {
    messageToUserForm: FormGroup = new FormGroup({});
    selectedUsers$: Observable<TableResponse<User>> = this.userManagementFacadeService.selectUsers$;

    constructor(
        private formBuilder: FormBuilder,
        private markdownService: MarkdownService,
        private ref: DynamicDialogRef,
        private userManagementFacadeService: UserManagementFacadeService
    ) {}

    // editor
    bsEditorInstance!: EditorInstance;
    editorOptions: EditorOption = {
        autofocus: false,
        iconlibrary: 'fa',
        savable: false,
        onFullscreenExit: () => this.hidePreview(),
        onShow: (e) => (this.bsEditorInstance = e),
        parser: (val) => this.parse(val),
        hiddenButtons: ['Image']
    };

    ngOnInit() {
        this.messageToUserForm = this.formBuilder.group({
            cc: new FormControl<string>('', [Validators.email]),
            title: new FormControl<string>(''),
            text: new FormControl<string>('')
        });
    }

    // getter
    get email() {
        return this.messageToUserForm.get('cc');
    }

    get text() {
        return this.messageToUserForm.get('text');
    }

    // editor functions
    hidePreview(): void {
        if (this.bsEditorInstance && this.bsEditorInstance?.hidePreview) {
            this.bsEditorInstance.hidePreview();
        }
    }
    parse(inputValue: string) {
        const markedOutput = this.markdownService.parse(inputValue.trim());
        this.highlight();

        return markedOutput;
    }
    highlight() {
        setTimeout(() => {
            this.markdownService.highlight();
        });
    }

    save() {
        this.ref.close(this.messageToUserForm.value);
    }

    close() {
        this.ref.close(false);
    }

    removeSelectedUser(userToRemove: User, totalRecords: number) {
        if (totalRecords <= 1) {
            this.ref.close(false);
        } else {
            this.userManagementFacadeService.removeSelectedUser(userToRemove);
        }
    }
}
